import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { LOCAL_STORAGE_USER_KEY, backUrl } from "../config";

// ВОЙТИ
export const loginQuery = createAsyncThunk(
  "authorizaiton/login",
  async ({ userInfo, navigate }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${backUrl}auth/local`, {
        identifier: userInfo.login,
        password: userInfo.password,
      });
      localStorage.setItem(LOCAL_STORAGE_USER_KEY, JSON.stringify(data));
      navigate("/home");
      return dispatch(loginAction({ data }));
    } catch (error) {
      return { error: `Ошибка в LoginQuery: ${error}` };
    }
  }
);

export const logoutActionHandler = ({ dispatch, navigate }) => {
  localStorage.removeItem(LOCAL_STORAGE_USER_KEY);
  dispatch(logoutAction());
  navigate("/");
};

const initialState = {
  accessToken: null,
  isAuth: false,
  login: null,
  id: null,
  username: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginAction(state, { payload }) {
      state.isAuth = true;
      state.accessToken = payload.data.jwt;
      state.login = payload.data.user.email;
      state.id = payload.data.user.id;
      state.username = payload.data.user.username;
    },
    logoutAction(state, { payload }) {
      state = initialState;
    },
  },
});

export const { loginAction, logoutAction } = authSlice.actions;
export const getIsAuthorized = (state) => state.login;
